import { render, staticRenderFns } from "./select-products.vue?vue&type=template&id=4fec3940&scoped=true&"
import script from "./select-products.vue?vue&type=script&lang=js&"
export * from "./select-products.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fec3940",
  null
  
)

export default component.exports